export const theme = {
  colors: {
    background: '#EDEDED',
    text: '#101010',
    red: '#EF2B2E',
    grey: '#5A5A5A',
    border: '#C9C9C9',
  },
  fonts: {
    body: 'Montserrat, sans-serif',
    headings: '"Ysabeau Infant", sans-serif',
  },
  ease: {
    out: [0.17, 0.84, 0.44, 1],
  },
} as const
